<template>
  <el-dialog
    title="欢迎扫码关注廉洁青山实业公众号！"
    v-if="centerDialogVisible"
    :visible.sync="centerDialogVisible"
    @close="handleClose"
    width="400px"
    center>
    <img src="../png/wx.jpg" style="width: 150px;height: 150px;margin-left: 100px">
    <span slot="footer" class="dialog-footer">
  </span>
  </el-dialog>
</template>

<script>
export default {
  name: "wxCode",
  props:["wxCodeOpen"],
  data() {
    return {
      centerDialogVisible: false
    };
  },
  mounted() {
    this.centerDialogVisible=this.wxCodeOpen;
  },
  methods:{
    handleClose(){
      this.centerDialogVisible = false;
      this.$emit('refreshDataList')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/web/wxCode.vue